import { FC, ReactNode } from 'react';

import { Flex, FlexProps, theme, Typography } from 'antd';

interface IOfferFeatureProps extends Omit<FlexProps, 'children'> {
	icon: ReactNode;
	label: string;
	description: string;
}

export const OfferFeature: FC<IOfferFeatureProps> = ({ icon, label, description, ...props }) => {
	const {
		token: { colorBgLayout, colorBorderSecondary },
	} = theme.useToken();

	return (
		<Flex
			{...props}
			gap={12}
			style={{
				backgroundColor: colorBgLayout,
				border: `1px solid ${colorBorderSecondary}`,
				padding: 12,
				borderRadius: 12,
			}}>
			<div>{icon}</div>
			<Flex vertical gap={4}>
				<Typography.Title level={5} style={{ margin: 0 }}>
					{label}
				</Typography.Title>
				<Typography.Text>{description}</Typography.Text>
			</Flex>
		</Flex>
	);
};
